import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { paths } from "@/routes/paths";

export function RouteErrorBoundary() {
  const error = useRouteError();

  let title = "Algo deu errado";
  let description = "Ocorreu um erro inesperado ao carregar esta tela.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText}`.trim();
    if (typeof error.data === "string" && error.data) description = error.data;
    else if (
      error.data &&
      typeof error.data === "object" &&
      typeof (error.data as { message?: string }).message === "string"
    ) {
      description = (error.data as { message: string }).message;
    }
  } else if (error instanceof Error && error.message) {
    description = error.message;
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex gap-2">
          <Button asChild>
            <Link to={paths.HOME}>Voltar para o início</Link>
          </Button>
          <Button variant="outline" onClick={() => window.location.reload()}>
            Recarregar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
